import $http from './http'
import config from './config'
export default {
    name: 'chargepolicy',
    getUrl(url) {
        return config.getUrl(this.name, url);
    },
    getChargeList(data){
        return $http.post(this.getUrl('/ChargeInfo/List'),data);
    },
    getChargeDetails(id){
        return $http.get(this.getUrl(`/ChargeInfo/Details/${id}`));
    },
    saveChargeInfo(data){
        return $http.post(this.getUrl('/ChargeInfo/Save'),data);
    },
    getProductInfo(data){
        return $http.post(this.getUrl('/PolicyInfo/ProductInfo'),data,{failTips:false});
    },
    CreatePolicy(data){
        return $http.post(this.getUrl('/PolicyInfo/CreatePolicy'),data);
    },

    getPolicyInfoList(data){
        return $http.post(this.getUrl('/PolicyInfo/List'),data)
    },
    getPolicyDetails(id){
        return $http.post(this.getUrl(`/PolicyInfo/Details/${id}`))
    },

    savePolicyInfo(data){
        return $http.post(this.getUrl('/PolicyInfo/Save'),data)
    },
    deletePolicyInfo(id){
        /**
         *  id 政策编号
         */
        return $http.get(this.getUrl(`/PolicyInfo/Delete/${id}`))
    },
    copyPolicyInfo(data){
        /**
         * {
         *          "PolicyId":""  ,//单条复制（其他不传）
         *          "SpaceId":"", // 从哪家公司复制的 id  公司复制
         *          "CompanyId":"", //给那家创建的公司 id
         *          "CompanyName":"" // 名称
         * }
         */
        return $http.post(this.getUrl('/PolicyInfo/CopyPolicyInfo'),data)
    },
    getThrowInfoList(data){
        return $http.post(this.getUrl('/throwinfo/list'),data);
    }
}


// WEBPACK FOOTER //
// ./src/apis/chargepolicyapi.js